import React from 'react';
import ReactDOM from 'react-dom';
import { browserHistory } from 'react-router';
import monitoring from 'utils/monitoring';
import Root from './containers/Root';

const bootstrapApp = (routes, store, domEl) => {
  // Render the React application to the DOM
  try {
    ReactDOM.render(
      <Root history={browserHistory} routes={routes} store={store} />,
      domEl || window.document.getElementById('root'),
    );
  } catch (error) {
    monitoring.sendError(error);

    /* eslint-disable no-console */
    if (console && console.error) {
      console.error(error);
    }
    /* eslint-enable no-console */
  }
};

export default bootstrapApp;



/** WEBPACK FOOTER **
 ** ./src/bootstrapApp.jsx
 **/